/**
 * User_Entity type guard.
 *
 * @param {any} userJson User object from API
 * @returns {boolean} Return true if type is User_Entity
 */
function validator(userJson: unknown): userJson is User_Entity {
  if (typeof userJson === "object" && userJson != null) {
    User_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(userJson).includes(element))
        console.log("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class User_Entity {
  static requiredFields = [
    "id",
    "firstName",
    "lastName",
    "userUUID",
    "createdAt",
    "updatedAt",
  ];

  constructor(userJson: unknown) {
    if (validator(userJson)) {
      this.id = userJson.id;
      this.firstName = userJson.firstName;
      this.lastName = userJson.lastName;
      this.userUUID = userJson.userUUID;
      this.createdAt = userJson.createdAt;
      this.updatedAt = userJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ User_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  firstName: string;
  lastName: string;
  userUUID: string;
  createdAt: string;
  updatedAt: string;
}
